module.exports = __webpack_public_path__ + "img/file_management.baded160.svg";